"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Undo_exports = {};
__export(Undo_exports, {
  default: () => Undo_default
});
module.exports = __toCommonJS(Undo_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.85156 4.76172C5.95573 4.67057 6.00781 4.5599 6.00781 4.42969C6.00781 4.28646 5.95573 4.16276 5.85156 4.05859C5.76042 3.96745 5.64323 3.92188 5.5 3.92188C5.35677 3.92188 5.23958 3.96745 5.14844 4.05859L2.49219 6.71484C2.3099 6.89714 2.21875 7.11849 2.21875 7.37891C2.21875 7.6263 2.3099 7.83464 2.49219 8.00391L5.14844 10.6602C5.23958 10.7643 5.35677 10.8164 5.5 10.8164C5.64323 10.8164 5.76042 10.7643 5.85156 10.6602C5.95573 10.569 6.00781 10.4518 6.00781 10.3086C6.00781 10.1654 5.95573 10.0482 5.85156 9.95703L3.72266 7.82812H13.8594C14.875 7.82812 15.7409 8.1862 16.457 8.90234C17.1732 9.61849 17.5312 10.4844 17.5312 11.5C17.5312 12.5156 17.1732 13.3815 16.457 14.0977C15.7409 14.8138 14.875 15.1719 13.8594 15.1719H7.60938C7.47917 15.1719 7.36198 15.224 7.25781 15.3281C7.16667 15.4193 7.12109 15.5299 7.12109 15.6602C7.12109 15.8034 7.16667 15.9271 7.25781 16.0312C7.36198 16.1224 7.47917 16.168 7.60938 16.168H13.8594C14.5104 16.168 15.1159 16.0443 15.6758 15.7969C16.2487 15.5495 16.7435 15.2174 17.1602 14.8008C17.5898 14.3841 17.9219 13.8893 18.1562 13.3164C18.4036 12.7435 18.5273 12.138 18.5273 11.5C18.5273 10.862 18.4036 10.2565 18.1562 9.68359C17.9219 9.11068 17.5898 8.61589 17.1602 8.19922C16.7435 7.78255 16.2487 7.45052 15.6758 7.20312C15.1159 6.95573 14.5104 6.83203 13.8594 6.83203H3.78125L5.85156 4.76172Z",
      fill: "currentColor"
    }
  )
);
const SvgUndo = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Undo_default = SvgUndo;
